import { DOCUMENT, inject, Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class DownloadService {
  private document = inject(DOCUMENT);

  downloadBase64File(base64: string, contentType: string, fileName: string): void {
    const byteArray = Uint8Array.from(atob(base64), (c) => c.charCodeAt(0));

    const blob = new Blob([byteArray], { type: contentType });
    this.triggerDownload(blob, fileName);
  }

  downloadBlob(blob: Blob, fileName: string): void {
    this.triggerDownload(blob, fileName);
  }

  private triggerDownload(blob: Blob, fileName: string): void {
    const url = URL.createObjectURL(blob);

    const anchor = this.document.createElement("a");
    anchor.href = url;
    anchor.download = fileName;
    anchor.style.display = "none";

    this.document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();

    queueMicrotask(() => URL.revokeObjectURL(url));
  }

  // downloadFile(content: string, contentType: string, fileName: string) {
  //   const byteCharacters = atob(content);
  //   const byteNumbers = new Array(byteCharacters.length);

  //   for (let i = 0; i < byteCharacters.length; i++) {
  //     byteNumbers[i] = byteCharacters.charCodeAt(i);
  //   }

  //   const byteArray = new Uint8Array(byteNumbers);
  //   const blob = new Blob([byteArray], { type: contentType });

  //   const url = window.URL.createObjectURL(blob);

  //   const link = document.createElement("a");
  //   link.href = url;
  //   link.download = fileName;

  //   link.click();

  //   setTimeout(() => {
  //     window.URL.revokeObjectURL(url);
  //     link.remove();
  //   }, 100);
  // }
}
